import { Link } from "react-router-dom";

import image from "./../../assets/imagem_sempermissao.png";

import styles from "./styles.module.scss";

export function Unauthorized() {
  return (
    <main className={styles.unauthorized}>
      <Link to="/">
        <button>Voltar a página inicial </button>
      </Link>
      <img src={image} alt="" />
    </main>
  );
}
